import React from "react";
import { Link } from "react-router-dom";
import { ReactComponent as GLogo } from "../assets/gear-heart.svg";
import { ReactComponent as GenerosLogo } from "../assets/generos-logo.svg";

function TransitionalHeader() {
  return (
    <header className="fixed bg-primary-6 w-full z-30">
      <div className="mx-auto px-4 sm:px-6">
        <div className="flex items-center justify-center h-20">
          <Link
            to="/"
            className="flex items-center font-semibold cursor-pointer rounded-lg p-1 -m-1 transition-opacity hover:opacity-90 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-1 focus-visible:ring-offset-2 focus-visible:ring-offset-primary-6"
            aria-label="Go to homepage"
          >
            <span className="mr-2 inline-flex" aria-hidden="true">
              <GLogo className="fill-current text-primary-1 w-10 pointer-events-none" />
            </span>
            <span className="inline-flex h-6" aria-hidden="true">
              <GenerosLogo className="fill-current text-white h-full w-auto pointer-events-none" />
            </span>
          </Link>
        </div>
      </div>
    </header>
  );
}

export default TransitionalHeader;
